import { makeAutoObservable } from "mobx";

class userState {
  constructor() {
    makeAutoObservable(this);
  }
  profile = {
    uploaded: false,
    id: null,
    name: "",
    last_name: "",
    email: "",
    phone: "",
    organization: null,
  };

  setProfile = async (
    id,
    name,
    last_name,
    father_name,
    email,
    phone,
    organization
  ) => {
    this.profile = {
      ...this.profile,
      id: id,
      name: name,
      last_name: last_name,
      father_name: father_name,
      email: email,
      phone: phone,
      organization: organization,
      uploaded: true,
    };
  };
}
export default new userState();
